import { render, staticRenderFns } from "./NotDataIcon.vue?vue&type=template&id=093df46c&scoped=true"
import script from "./NotDataIcon.vue?vue&type=script&lang=js"
export * from "./NotDataIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093df46c",
  null
  
)

export default component.exports